/* [DC] - 28th Sep 2026 - Selleasy PDP addon widget hooks.
   Loaded from layout/theme.liquid on product pages only.
   Changes what the PDP addon widget displays - cart, checkout
   and orders keep the full product title.
   Both maps match the product name exactly as Selleasy renders it.
   If a product title changes in Shopify, its entry quietly stops
   applying (the widget shows the real title) until updated here.
   Prices are reformatted to match snippets/product-price.liquid:
   no trailing .00, commas dropped under $10,000, superscript $ and cents.
   Styling lives in assets/custom.css (.vcs-addon-note, .vcs-price-sup). */
(function () {
  // Full product title -> name shown in the widget
  var RENAMES = {
    'Espresso Machine Preventative Maintenance Annual Subscription':
      'Preventative Maintenance Annual Subscription'
  };

  // Full product title -> note shown under the price
  var NOTES = {
    'La Marzocco Commercial Extended Warranty':
      'Includes Preventative Maintenance Annual Plan'
  };

  var WIDGET = 'lb-upsell-product-page-addon';
  var NOTE_CLASS = 'vcs-addon-note';

  function has(map, key) {
    return Object.prototype.hasOwnProperty.call(map, key);
  }

  var PRICE_ATTR = 'data-vcs-price';

  // Mirrors snippets/product-price.liquid:
  // money_without_trailing_zeros, remove ',' when price <= 999999 cents,
  // superscript currency symbol and cents.
  function formatPrice(el) {
    var current = el.textContent.trim();
    if (el.getAttribute(PRICE_ATTR) === current) return; // already ours
    var m = current.match(/^([^\d]*)([\d,]+)(?:\.(\d{2}))?$/);
    if (!m) return; // unexpected format - leave Selleasy's text alone
    var symbol = m[1];
    var dollars = m[2];
    var cents = m[3] || '00';
    var priceInCents = parseInt(dollars.replace(/,/g, '') + cents, 10);
    if (priceInCents <= 999999) dollars = dollars.replace(/,/g, '');

    while (el.firstChild) el.removeChild(el.firstChild);
    if (symbol) {
      var sup = document.createElement('span');
      sup.className = 'vcs-price-sup vcs-price-cur';
      sup.textContent = symbol;
      el.appendChild(sup);
    }
    el.appendChild(document.createTextNode(dollars));
    if (cents !== '00') {
      var c = document.createElement('span');
      c.className = 'vcs-price-sup';
      c.textContent = cents;
      el.appendChild(c);
    }
    el.setAttribute(PRICE_ATTR, el.textContent.trim());
  }

  function apply() {
    var prices = document.querySelectorAll(WIDGET + ' .lb-upsell-money-2');
    for (var p = 0; p < prices.length; p++) formatPrice(prices[p]);

    var names = document.querySelectorAll(WIDGET + ' .lb-spc-details-name');
    for (var i = 0; i < names.length; i++) {
      var nameEl = names[i];
      var title = nameEl.textContent.trim();

      // Note - added once per card, after the price
      if (has(NOTES, title)) {
        var details = nameEl.closest('.lb-spc-details-cont');
        var price = details && details.querySelector('.lb-spc-details-price-cont');
        if (price && !details.querySelector('.' + NOTE_CLASS)) {
          var note = document.createElement('div');
          note.className = NOTE_CLASS;
          note.textContent = NOTES[title];
          price.insertAdjacentElement('afterend', note);
        }
      }

      // Rename - once swapped, the text no longer matches, so it stops
      if (has(RENAMES, title)) {
        nameEl.textContent = RENAMES[title];
      }
    }
  }

  apply();
  new MutationObserver(apply).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();